import { Injectable } from '@angular/core';
import { Subject, shareReplay } from 'rxjs';
import { WpMenuService } from 'src/app/services/wp-menu.service';

export interface MenuItem {
  state: string;
  name: string;
  order?: number;
  type: string;
  icon: string;
  pagetitle: string;
  classes?: string;
  target?: string;
  object_id?: string; // id dell'oggetto del menu; viene utilizzato per effettuare il mapping con i children
  children?: MenuItem[];
  is_new?: boolean;
  show_promo?: boolean;
  promo_text?: string | null;
  promo_weight?: number;
}

export const MENUDELFI = [
  { state: 'dashboard-dynamic', name: 'Dashboard', type: 'link', icon: '', pagetitle: 'Dashboard' },
  // { state: 'business-analysis', name: 'Business', type: 'link', icon: '', pagetitle:'Business' },
  // { state: 'innovation-path', name: 'Innovation Path', type: 'link', icon: '', pagetitle:'Percorsi di innovazione' },
  { state: 'marketplace', name: 'Marketplace', type: 'link', icon: '', pagetitle:'Marketplace' },
  { state: 'selfcaring', name: 'Selfcaring', type: 'link', icon: '', pagetitle: 'Selfcaring' },
  // { state: 'progetto-innovativo', name: 'Progetto d\'innovazione', type: 'link', icon: '', pagetitle: 'Progetto d\'innovazione' },
  // { state: 'digital-report', name: 'Benchmark', type: 'link', icon: '', pagetitle:'Benchmark' },
  // { state: 'bandi', name: 'Bandi', type: 'hidden', icon: '', pagetitle:'Bandi per l\'innovazione' },
];

export const MENUUSER = [
  { state: 'user-info', name: 'Profilo loggato', type: 'info', icon: 'account_circle', pagetitle:'Profilo' },
  // { state: 'user-profile', name: 'Profile', type: 'link', icon: 'account_circle', pagetitle:'Profilo' },
  // { state: '/logout', name: 'Logout', type: 'url', icon: 'logout', pagetitle:'Logout' },
  { state: '/logout', name: 'Logout', type: 'to-replace', icon: 'logout', pagetitle:'Logout' },
];

export interface PromoMenuItem {
  promo_title: string;
  promo_text: string;
  menu_state: string;
  promo_weight: number;
}

@Injectable()
export class MenuItems {
  navigationMenu!: MenuItem[];
  userMenu!: MenuItem[];
  overviewMenu: MenuItem[] = MENUDELFI;

  overviewSubject!: Subject<MenuItem[]>;
  userMenuSubject!: Subject<MenuItem[]>;
  promoModalSubject!:Subject<PromoMenuItem[]>

  constructor(
    private menuService: WpMenuService
  ) {
    this.init();
  }

  init(forceReload?: boolean){
    if(forceReload) {
      this.menuService._reloadMenu();
    }
    this.menuService.getMenuItems().then((menu: any) => {
      this.navigationMenu = menu;
      this.createMenuPromosSubject();
      this.createOverviewSubject();
     
      
      this.overviewSubject.next(this.navigationMenu);
      this._getPromosInMenuItems(this.navigationMenu).then(promos => {
        if (promos) {
          this.promoModalSubject.next(promos);
        }
      }).catch((err) => {
        console.log('err', err);
      })
    });
    this.menuService.getUserMenuItems().then((userMenu: any) => {
         this.createUserMenuSubject();
        this.userMenuSubject.next(userMenu);
        this.userMenu = userMenu;
      });
    
   }

   createOverviewSubject() {
    if(this.overviewSubject)
      return this.overviewSubject;
    this.overviewSubject = new Subject<MenuItem[]>();
     this.overviewSubject = this.overviewSubject.pipe(shareReplay(1)) as Subject<MenuItem[]>
    this.overviewSubject.subscribe((menuItems) => {
    });
    return this.overviewSubject;
   }

   createUserMenuSubject() {
    if(this.userMenuSubject)
      return this.userMenuSubject;
    this.userMenuSubject = new Subject<MenuItem[]>();
     this.userMenuSubject = this.userMenuSubject.pipe(shareReplay(1)) as Subject<MenuItem[]>;
    //  this.userMenuSubject.subscribe((menuItems) => {
    // });
    return this.userMenuSubject;
   }
  
  createMenuPromosSubject(): Subject<PromoMenuItem[]> {
    if (this.promoModalSubject) {
      return this.promoModalSubject;
    }
    this.promoModalSubject = new Subject<PromoMenuItem[]>();
    this.promoModalSubject = this.promoModalSubject.pipe(shareReplay(1)) as Subject<PromoMenuItem[]>;
    // this.promoModalSubject.subscribe((menuItems) => {
    //  //  console.log("MenuItems", menuItems);
    // });
    return this.promoModalSubject;
  }
  _getPromosInMenuItems(navigationMenu: MenuItem[]): Promise<PromoMenuItem[]> {
    return new Promise((resolve, reject) => {
      let promos:any = navigationMenu.filter(menuItem => menuItem.show_promo)
      .map(menuItem => ({ promo_title:menuItem.name, promo_text: menuItem.promo_text, menu_state: menuItem.state, promo_weight: menuItem.promo_weight || 0 }));
     
      if (promos.length > 0) {
        if (promos.length > 1){
            promos.sort((a: PromoMenuItem, b: PromoMenuItem) => {
              return b.promo_weight - a.promo_weight ;
            });
        }
        resolve(promos);
      } else {
        reject(false);
      }
    });
   
  }

  getPromosInMenuSubject():Subject<PromoMenuItem[]> {
    this.createMenuPromosSubject();
    return this.promoModalSubject;
  }

  // getMenuitems(): Menu[] {
  //   return MENUITEMS;
  // }
  getOverviewItems(): Subject<MenuItem[]> {
    this.createOverviewSubject();
    // setTimeout(() => {
    this.overviewSubject.next(this.overviewMenu);
    // }, 1000);
    return this.overviewSubject;
  }

  addToMenu(type: 'overview' | 'user' | 'navigation', menu: MenuItem) {
    if (type === 'overview') {
      if (!this.overviewMenu.find(item => item.state === menu.state)) {
        this.overviewMenu.push(menu);
      }
      this.overviewSubject.next(this.overviewMenu);
    } else if (type === 'user') {
      if (!this.userMenu.find(item => item.state === menu.state)) {
        this.userMenu.push(menu);
      }
      this.userMenuSubject.next(this.userMenu);
    } else if (type === 'navigation') {
      if (!this.navigationMenu.find(item => item.state === menu.state)) {
        this.navigationMenu.push(menu);
      }
      this.overviewSubject.next(this.navigationMenu);
    }
  }

  getUserMenuItems(): Subject<MenuItem[]> {
    this.createUserMenuSubject();
    // setTimeout(() => {
      this.userMenuSubject.next(MENUUSER);
    // }, 1000);
    return this.userMenuSubject;
  }

  // getUserMenuItems(): MenuItem[] {
  //   return MENUUSER;
  // }

  getPageTitle(state: string): string {
    // let menuitems: Array<any> = this.getOverviewItems();
    // let menuitems: Array<any> = MENUDELFI;
    let pagetitle = 'pagetitle'
    let el = null
    if (this.navigationMenu) {
      el = this.navigationMenu.find(item => item.state.toLocaleLowerCase() === state.toLocaleLowerCase());
    }
    if(!el && this.userMenu) {
      el = this.userMenu.find(item => item.state.toLocaleLowerCase() === state.toLocaleLowerCase());
    }
    if(el)
        pagetitle = el.pagetitle;
    return pagetitle;
  
  }
    
}
